import {ADDROUTEINFO, REMOVE_END_ROUTER} from "./type";

const routerStorage = {
  state: () => ({
     routers:[]
   }),
  namespaced:true,
  mutations: {
    [ADDROUTEINFO]:(state,obj) => {
      state.routers = [...state.routers,obj]
    },
    //删除数组最后一个
    [REMOVE_END_ROUTER]:(state) =>{
      state.routers = state.routers.slice(0,state.routers.length - 2)
    }
  },
  actions:{
    [ADDROUTEINFO]({ commit },payload){
      commit(ADDROUTEINFO,payload.obj)
    },
    [REMOVE_END_ROUTER]({commit}){
      commit(REMOVE_END_ROUTER)
    }
  },
  getters: {
     //获取数组最后第二位
     gainroutersPop:state => {
       const routers = state.routers
       const length = routers.length
       if(length >= 2){
         return routers[length - 2]
       }else {
         return null
       }
     }
  }
}
export default routerStorage



// WEBPACK FOOTER //
// ./src/vuex/routeStorage/index.js